<template>
  <v-app id="error">
    <v-container
      fluid
      fill-height
    >
      <v-layout
        align-center
        justify-center
        row
      >
        <div
          class="text-md-center"
        >
          <img
            src="/static/M-CORES/AdminPanelNav.png"
            class="fdot-logo text-md-center"
          >
        </div>
        <div
          v-if="['404'].includes(error)"
          class="text-md-center"
        >
          <h1 class="errorCode">
            {{ error }}
          </h1>
          <h2 class="my-3 headline ">
            Sorry, the page you're looking for was not found.
          </h2>
          <br>
          <h2 class="my-3 headline ">
            Please double check the url.
          </h2>
        </div>
        <div
          v-if="error === 'InvalidSurvey'"
          class="text-md-center"
        >
          <h1 class="errorCode">
            Invalid Survey Route
          </h1>
          <h2 class="my-3 headline ">
            Sorry, the survey you're looking for was not found.
          </h2>
          <br>
          <h2 class="my-3 headline ">
            Please double check the url and ensure that the combination of program, project, and survey is valid.
          </h2>
        </div>
        <div
          v-if="error === 'LockedSurvey'"
          class="text-md-center"
        >
          <h1 class="errorCode">
            Survey not open <br> at this time
          </h1>
          <h2 class="my-3 headline ">
            Please contact survey administrator for questions
          </h2>
        </div>
        <div
          v-if="error === 'NoViewMultipleSurveySelection'"
          class="text-md-center"
        >
          <h1 class="NoViewMultipleSurveySelection">
            This program is currently not <br> available to select a survey from.
          </h1>
          <h2 class="my-3 headline ">
            If you wish to access a survey please uses it's full URL otherwise <br>
            Please contact survey administrator for questions
          </h2>
        </div>
        <div
          v-if="error === 'InvalidProgram'"
          class="text-md-center"
        >
          <h1 class="errorCode">
            Program doesn't Exist
          </h1>
          <h2 class="my-3 headline ">
            Please double check the url
          </h2>
        </div>
        <div
          v-if="error === 'IE'"
          class="text-md-center"
        >
          <h2 class="errorCode">
            Please access the admin panel from a supported browser <br>
            such as Chrome, Firefox, or Edge
          </h2>
        </div>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
export default {
  props: { error: { type: String, default: "404" }}
};
</script>

<style>
.d {
  margin: 0 auto;
  width: 25% !important;
}
.errorCode {
  text-align: center;
  vertical-align: middle;
  color: #424242;
  text-shadow: rgba(61, 61, 61, 0.3) 1px 1px, rgba(61, 61, 61, 0.2) 2px 2px,
    rgba(61, 61, 61, 0.3) 3px 3px;
}
.NoViewMultipleSurveySelection {
  text-align: center;
  vertical-align: middle;
  font-size: 80px;
  line-height: 120px;
  font-weight: 600;
  color: #424242;
  text-shadow: rgba(61, 61, 61, 0.3) 1px 1px, rgba(61, 61, 61, 0.2) 2px 2px,
    rgba(61, 61, 61, 0.3) 3px 3px;
}
.fdot-logo {
  margin-bottom: -10%;
  width: 40%;
}
</style>
